
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import useValidate from "../../store/hooks/useValidator";
import { useDispatch } from "react-redux";
import { callApiAction } from "../../store/actions/commonAction";
import { closeModal, openModal } from "../../store/actions/modalAction";
import { PAYMENT_METHOD, SNACK_BAR_VARIETNS, STATUS } from "../../utils/constants";
import { callSnackBar } from "../../store/actions/snackbarAction";
import { getRepairingTicketStatusByIdApi, RepairingUpdateTicketApi, updateOtpApi } from "../../apis/repairing.api";
import UpdateCreateQueryUi from "./UpdateCreateQueryUi";
import { statusActionFilters, statusCountActionFilters } from "../../store/actions/statusAction";
import { FetchProblemApi } from "../../apis/problem.api";
import { fetchNotificationAction } from "../../store/actions/notificationAction";
import { getProductAccessoriesApi } from "../../apis/productAccessories.api";
import OtpInput from "../../components/OtpInput";
import { getProdutApi, ProductFindByIdApi } from "../../apis/product.api";
import moment from "moment";

const UpdateCreateQueryController = ({ statusPass, isOtp, fieldTicket, setTickets, id }) => {
  const [fields, setFields] = useState({
    id: id,
    err: "",
    createdAt: fieldTicket?.createdAt ? fieldTicket?.createdAt : "",
    ticket_no: fieldTicket?.ticketNo ? fieldTicket?.ticketNo : "",
    product_id: "",
    box_id: "",
    customer_phone: "",
    customer_name: "",
    customer_email: "",
    source_id: "",
    trakingId: "",
    problems: [],
    solved_in: "",
    customer_address: "",
    conclusion: "",
    other: "",
    repairing_amount_status: "",
    dispatch_remarks: "",
    warrenty_date: "",
    manufacturer_date: "",
    completed: "",
    otp: "",
    product_accessories: [],
    country:"",
    state:"",
    city:"",
    is_warranty_3_yr:null,
  });

  const [variant1, setVariant] = useState();
  const [validation, setvalidation] = useState(false);
  const [loading, setLoading] = useState(false);
  const validate = useValidate();
  const dispatch = useDispatch();
  const modalKey = 'Query';
  const title = "Query";
  const selectedDispatch = useRef(null);
  const [listProblem, setlistProblem] = useState()
  const [productAccessories, setProductAccessories] = useState()
  const [listItem, setlistItem] = useState()
  const validationSchemaForUpdate = useMemo(
    () => [
      {
        required: true,
        value: fields.ticket_no,
        field: "Ticket No",
      },
      {
        required: true,
        value: fields.createdAt,
        field: "createdAt",
      },
      {
        required: true,
        value: fields.product_id,
        field: "Product",
      },
      {
        required: false,
        value: fields.customer_email,
        field: "Email",
      },
      {
        required: fields?.problems.some((item) => item.toLowerCase() === "other"),
        value: fields.other,
        field: "other",
      },
      {
        required: false,
        value: fields.box_id,
        field: "Box Id",
      },
      {
        required: true,
        value: fields.customer_phone,
        field: "customer_phone",
      },
      {
        required: true,
        value: fields.customer_name,
        field: "Customer Name",
      },
      {
        required: true,
        value: fields.source_id,
        field: "Source",
      },
      {
        required: true,
        value: fields.problems.length,
        field: "Problems",
      },
      {
        required: false,
        value: fields.solved_in,
        field: "solved_in",
      },
      {
        required: true,
        value: fields.customer_address,
        field: "Customer Address",
      },
      {
        required: statusPass === STATUS.EVALUATION && true,
        value: fields.product_accessories.length,
        field: "Product Accessories",
      },
      {
        required: statusPass === STATUS.EVALUATION && true,
        value: fields.warrenty_date,
        field: "Purchase Date",
      },
      {
        required: statusPass === STATUS.EVALUATION && true,
        value: fields.conclusion,
        field: "Send to Repair Team",
      },
      {
        required: statusPass === STATUS.WAITING_FOR_PAYMENT && true,
        value: fields.repairing_amount_status,
        field: "Pending Payment Status",
      },
      {
        required: statusPass === STATUS.WAITING_FOR_PAYMENT && fields.repairing_amount_status === PAYMENT_METHOD.CANCEL_PAYMENT && true,
        value: selectedDispatch.current,
        field: "Customer need Devices Back",
      },
      {
        required: statusPass === STATUS.WAITING_FOR_PAYMENT && true,
        value: fields.status?.length,
        field: "Repairing Feasible",
      },
      {
        required: (statusPass === STATUS.WAITING_FOR_PAYMENT && fields.repairing_amount_status === PAYMENT_METHOD.CANCEL_PAYMENT) && true,
        value: fields.dispatch_remarks,
        field: "Remarks",
      },

    ],
    [fields, statusPass]
  );

  const filters = useMemo(() => ({
    pageNo: 1,
    pageSize: 10,
    search: "",
    searchable: ['cName'],
    role: "",
    sort: "createdAt",
    sortDirection: -1,
  }), []);

  const fetchList = (id) => {
    return new Promise((resolve, reject) => {
      dispatch(
        callApiAction(
          async () => await ProductFindByIdApi({ id }),
          (response) => {
            const problems = response?.problems || [];
            setlistProblem(problems);
            setProductAccessories(response?.product_accessories || [])
            resolve(problems);
            setlistItem(response?.item || [])
          },
          (err) => {
            console.log("Error", err);
            reject(err);
          }
        )
      );
    });
  };

  const fetchById = useCallback((id) => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await getRepairingTicketStatusByIdApi({ id }),
        async (response) => {
          setFields(prev => ({ ...prev, ...response }));
          setLoading(false);
          try {
            const data = await fetchList(response?.product_id?._id);
            const todayDate = moment();
            const warrantyDate = moment(response?.warrenty_date);
            const SelectedProblem = data.filter(problem => response.problems.some(p => p.toLowerCase() === problem.name.toLowerCase())) || []
            for (const item of SelectedProblem) {
              const isYear = warrantyDate.isValid() && Math.trunc((new Date(todayDate) - new Date(warrantyDate)) / (1000 * 60 * 60 * 24)) / 365 <= item.warrenty;
              if (!isYear) {
                setvalidation(true);
                break;
              } else {
                setvalidation(false);
              }
            }
          } catch (err) {
            console.error("Error fetching list in fetchById:", err);
          }
        },
        (err) => {
          setFields(prev => ({ ...prev, err }));
          setLoading(false);
        }
      )
    );
  }, [dispatch]);

  useEffect(() => {
    if (id) fetchById(id);
  }, [id, fetchById]);

  const onSubmit = async (e, isOtpTrue) => {
    e.preventDefault();
    const validationResponse = validate(validationSchemaForUpdate)
    if (validationResponse === true) {
      setLoading(isOtpTrue ? false : true)
      dispatch(callApiAction(
        async () => await RepairingUpdateTicketApi({ ...fields, completed_status: isOtpTrue ? "Device Received" : "", product_id: fields.product_id?._id, source_id: fields.source_id?._id, country: fields.country?._id ? fields.country?._id : fields.country, state: fields.state?._id ? fields.state?._id : fields.state, city: fields.city?._id ? fields.city?._id : fields.city }),
        (response) => {
          setLoading(false)
          dispatch(closeModal("UpdateQuery"))
          dispatch(closeModal("Otp"))
          dispatch(callSnackBar("Updated Successfully", SNACK_BAR_VARIETNS.suceess));
          dispatch(fetchNotificationAction());
          dispatch(statusActionFilters(filters));
          dispatch(statusCountActionFilters(-1));
        }, (err) => {
          setFields({ ...fields, err });
          setLoading(false);
        }))
    } else {
      setFields({ ...fields, err: validationResponse })
      setLoading(false)
    }
  };

  const onOTPSubmit = async (e, isOtpTrue) => {
    e.preventDefault();
    const validationResponse = validate(validationSchemaForUpdate)
    if (validationResponse === true) {
      setLoading(isOtpTrue ? false : true)
      dispatch(callApiAction(
        async () => await updateOtpApi({ ...fields, completed_status: isOtpTrue ? true : false, product_id: fields.product_id?._id, source_id: fields.source_id?._id }),
        (response) => {
          setLoading(false)
          dispatch(closeModal("UpdateQuery"))
          dispatch(closeModal("Otp"))
          dispatch(callSnackBar("Updated Successfully", SNACK_BAR_VARIETNS.suceess));
          dispatch(fetchNotificationAction());
          dispatch(statusActionFilters(filters));
          dispatch(statusCountActionFilters(-1));
        }, (err) => {
          setFields({ ...fields, err });
          setLoading(false);
        }))
    } else {
      setFields({ ...fields, err: validationResponse })
      setLoading(false)
    }
  };

  const OtPCheck = (e, otp) => {
    e.preventDefault()
    const isOtpTrue = Number(otp) === fields?.otp

    if (isOtpTrue) {
      onOTPSubmit(e, isOtpTrue)
    } else {
      setFields({ ...fields, err: "Please Enter a Valid OTP" })
    }
  }

  const handleOtp = useCallback((e) => {
    dispatch(openModal(<OtpInput data={fields?.err} handleOTPSubmit={(e, otp) => OtPCheck(e, otp)} fields={fields}
    />, "sm", true, "Otp"))
  }, [fields, dispatch])

  useEffect(() => {
    if (isOtp) {
      handleOtp()
    }
  }, [isOtp, handleOtp])

  return (<UpdateCreateQueryUi
    listProblem={listProblem}
    statusPass={statusPass}
    modalKey={modalKey}
    title={title}
    loading={loading}
    fields={fields}
    onSubmit={onSubmit}
    setFields={setFields}
    isOtp={isOtp}
    variant1={variant1}
    setVariant={setVariant}
    productAccessories={productAccessories}
    selectedDispatch={selectedDispatch}
    setvalidation={setvalidation}
    validation={validation}
    listItem={listItem}
  />
  );
};
export default memo(UpdateCreateQueryController);
